document.addEventListener('DOMContentLoaded', function () {
    
    let selectList = [];//选择列表
    let renderProductList = [];//渲染的列表(扁平化数组)
    let newRenderProductList = [];//去重数组
    let tag_list_get = [];//tag_list原数据
    let newFilterList = [];//filter列表
    let totalNum = 0;//选择的总数
    let variant_id_list = [];// variant_id列表
    let hasMoved = false; // 是否已经移动过
    let product_lists = [];// 产品列表id集合
    let all_product_list = [];// 所有产品列表id集合
    let product_list_get = [];//针对产品详情

    // 渲染分类列表
    function renderCategoryList(tag_list) { 
     $('.category-text').empty();
      tag_list.forEach((item,index) => {
        $('.category-text').append(`
          <div class="category-item">
            <div data-index="${index}" class="category-name-list" onclick="selectCategory(this,event)"><span class="category-quare"></span>${item.tag}</div>
          </div>
        `)
      })
    }

    // 展开收起
    window.categoryClick = function(e) {
      if(window.innerWidth <= 1024){
        const $clickedItem = $(e);
      
        // 切换当前点击项的状态
        if ($clickedItem.hasClass('is-open')) {
            // 如果当前项是展开状态，则收起它
            hideBg();
            $clickedItem.removeClass('is-open');
            if(window.innerWidth <= 1024) {
              $('.scene-collocation .h5-bot-tri').removeClass('is-rotated'); // 添加旋转类名
            }
        } else {
            // 如果当前项是收起状态，则展开它
            $clickedItem.addClass('is-open');
            if(window.innerWidth <= 1024){
              $('.scene-collocation .hide-scene-list-bg').show();
            }else{
              $('.scene-collocation .hide-scene-list').show();
            }
            if(window.innerWidth <= 1024) {
              // $('.scene-collocation .category-list-wrap').show();
              $('.scene-collocation .h5-bot-tri').addClass('is-rotated'); // 添加旋转类名
            }
        }
      }
    }

    // 查看更多
    window.viewMoreClick = function(e,clickedItem) {
      e.stopPropagation();
      const $clickedItemMore = $(clickedItem);
      if ($clickedItemMore.hasClass('is-up')) {
        $clickedItemMore.removeClass('is-up');
        $clickedItemMore.find('.topTri').attr('src','https://cdn.heychic.net/material/review/botTri-d4c4e28fed9a8f4.png');

        $('.category-text .category-item').each(function(i) { 
          if(i > 2){
            $(this).find('.category-name-list').addClass('is-active');
          }
        });
        // renderCategoryList(tag_list_get);
      } else {
        $clickedItemMore.addClass('is-up');
        $clickedItemMore.find('.topTri').attr('src','https://cdn.heychic.net/material/review/topTri-a9ad455b30d8ee9.png');
        $('.category-item .category-name-list').removeClass('is-active');
      }
    }

    // 是否选中
    window.selectCategory = function(item,e) { 
      e.stopPropagation();
      const $selectItem = $(item);
      const index = $selectItem.attr('data-index'); // 获取当前点击项的索引
      if($selectItem.hasClass('is-select')) {
        $selectItem.removeClass('is-select');
        $selectItem.find('.category-quare').empty();
        selectList = selectList.filter(e => e !== item.textContent); // 移除选中项
        newFilterList = newFilterList.filter(e => e.tag !== item.textContent); // 移除选中项

        // 重新计算总数
        totalNum = 0;
      } else {
        $selectItem.addClass('is-select');
        $selectItem.find('.category-quare').append(`<img src="https://cdn.heychic.net/material/review/categorytrue-ebcb3b10712ef43.png" class="check-icon" />`);
        selectList.push(item.textContent); // 添加选中项
        
        newFilterList.push(tag_list_get[index]);
      }

      const newSelectList = [...new Set(selectList)]; // 去重过滤掉重复项
      $('.apply-text .apply-nums').text(newSelectList.length);

      renderProductList = [];
      newFilterList.forEach((r,t) => { 
        renderProductList.push(r.data_list);
      })

      newRenderProductList = [...new Map(renderProductList.flat().map(d => [d.id, d])).values()]; //去重(id)
      totalNum = newRenderProductList.length;
      $('.bot-numbers .select-nums').text(totalNum);

      if(window.innerWidth > 1024){
        rightCategoryProduct(totalNum == 0 ? tag_list_get : newFilterList);
      }
    }

    function hideBg() {
      if(window.innerWidth <= 1024){
        $('.scene-collocation .hide-scene-list-bg').hide();
      }else{
        $('.scene-collocation .hide-scene-list').hide();
      }
    }

    // 折叠菜单
    function collapseMenu() { 
      $('.category-name-list').removeClass('is-select');
      $('.category-name-list').find('.category-quare').empty();
      $('.category-name').removeClass('is-open');
      if(window.innerWidth <= 1024) {
        $('.scene-collocation .hide-scene-list-bg').hide();
      }
      $('.scene-collocation .h5-bot-tri').removeClass('is-rotated'); // 移除旋转类名
    }
    // 清除筛选项
    window.clearInfo = function(e) {
      e.stopPropagation();
      collapseMenu();
      $('.apply-text .apply-nums').text(0);
      $('.bot-numbers .select-nums').text(0);
      totalNum = 0;
      newFilterList = [];
      rightCategoryProduct(tag_list_get);
    }


    // 应用筛选
    window.applyInfo = function(e) { 
      e.stopPropagation();
      rightCategoryProduct(totalNum == 0 ? tag_list_get : newFilterList);
      $('.category-name').removeClass('is-open');
      hideBg();
      $('.scene-collocation .h5-bot-tri').removeClass('is-rotated'); // 移除旋转类名
    }

    // 分类列表产品
    function rightCategoryProduct(tag_list) { 
      $('.collocation-cont-right-all').removeClass('has-halo-block-loader');
      renderProductList = [];
      $('.collocation-cont-right').empty();
      if(window.location.pathname.includes('/products')){ 
        newRenderProductList = tag_list;
      }else{
        tag_list.forEach((r,t) => { 
          renderProductList.push(r.data_list);
        })
        newRenderProductList = [...new Map(renderProductList.flat().map(d => [d.id, d])).values()]; //去重(id)
      }
      
      $(".collocation-cont-left-title .total-nums").text(newRenderProductList.length);//总数(组合)
      newRenderProductList.forEach((item,index) => {
        const imgType = item.type;
        $('.collocation-cont-right').append(`
          <div class="collocation-cont-right-item">
            <div class="swiper collocation-swiper-pic">
              <div class="collocation-cont-right-item-wrapper swiper-wrapper">
                ${
                  item.material_config.show_data.map((t,y) => {
                      return `
                      <div class="swiper-slide" onclick="collocationDetail(${item.id},${y})">
                        <img 
                         src="https://cdn.heychic.net/material/review/1-e4c21281e6e3796.jpg"
                         data-src="${imgType == 1 ? t.url : t.cover}"
                         alt="collocation-cont-right-item-img" 
                         class="collocation-cont-right-item-img swiper-lazy lazy-img" 
                         >
                         ${
                          window.innerWidth > 1024 ? `
                          <div class="scene-add">ADD TO BAG <img src="https://cdn.heychic.net/material/review/botAdd-c1bc152bfc0d92d.png" class="add-scene" alt="add-scene"/></div>
                          ` : ''
                         }
                      </div>
                        
                      `
                    }).join('')
                }
              </div>
            </div>

            <div class="swiper collocation-swiper">
                <div class="collocation-cont-right-item-bot swiper-wrapper">
                  ${
                    item.material_config.show_data.map((v,j) => {
                        return `
                          <img 
                          data-src="${imgType == 1 ? v.url : v.cover}"
                          alt="" 
                          class="collocation-cont-right-item-bot-img swiper-slide lazy-img">
                        `
                      }).join('')
                  }
                </div>
            </div>
            ${
              window.location.pathname.includes('/scene-collocation') ? `<div class="collocation-cont-bot-info" onclick="collocationDetail(${item.id})">
                <div class="bot-info-text ${item.material_config.product_data.length <= 2 ? 'bot-info-text-two' : item.material_config.product_data.length > 2 ? 'bot-info-text-three' : 'bot-info-text-four'}">
                  ${
                    item.material_config.product_data.map((t,y) => {
                      // 根据产品id筛选出对应的产品价格
                      const filter_list = all_product_list.filter(item => item.id.includes(t.product_number));
                        return `
                        <div class="info-text">
                          <div class="info-text-left">${t.product_title}</div>
                          <div class="info-text-right">
                            ${getCurrencySymbolAll(window.Shopify.currency.active)}${filter_list[0].priceRange.maxVariantPrice.amount} ${window.Shopify.currency.active}
                          </div>
                        </div>
                        `
                    }).join('')
                  }
                </div>  
                <div class="bot-info-add">ADD TO BAG</div>
            </div>` : ``}
            
          </div>
        `)
      })

      botImgSwiper();
      // 懒加载
      const getInfo = document.querySelectorAll('.collocation-cont-right');
      getInfo.forEach(item => {
        initLazyImages(item);
      })

      // pc详情针对滑动问题
      if (window.location.pathname.includes('/products')) {
        const sliderContainer = document.querySelector('.product-collocation .collocation-cont-right');
        const scrollContainer = document.querySelector('.product-collocation .collocation-cont-right');
        const scrollThumb = document.querySelector('.product-collocation .scroll-thumb');

        let isDragging = false;
        let startX;
        let scrollLeft;
        let hasMoved = false;

        if(window.innerWidth > 1024){
          // ========== PC 鼠标事件 ==========
        sliderContainer.addEventListener('mousedown', (e) => {
          isDragging = true;
          hasMoved = false;
          startX = e.pageX - sliderContainer.offsetLeft;
          scrollLeft = sliderContainer.scrollLeft;
          e.preventDefault();
        });

        sliderContainer.addEventListener('mousemove', (e) => {
          if (!isDragging) return;
          const x = e.pageX - sliderContainer.offsetLeft;
          
          if (Math.abs(x - startX) > 5) {
            hasMoved = true;
          }

          const walk = (x - startX) * 1.5;
          sliderContainer.scrollLeft = scrollLeft - walk;
          $('.collocation-modal').hide();
        });

        sliderContainer.addEventListener('mouseup', () => {
          isDragging = false;
          $('.collocation-modal').hide();
        });

        sliderContainer.addEventListener('mouseleave', () => {
          isDragging = false;
        });
        }else{
          // ========== H5 触摸事件 ==========
        sliderContainer.addEventListener('touchstart', (e) => {
          isDragging = true;
          hasMoved = false;
          startX = e.touches[0].pageX - sliderContainer.offsetLeft;
          scrollLeft = sliderContainer.scrollLeft;
          // e.preventDefault();
        });

        sliderContainer.addEventListener('touchmove', (e) => {
          if (!isDragging) return;
          const x = e.touches[0].pageX - sliderContainer.offsetLeft;
          
          if (Math.abs(x - startX) > 5) {
            hasMoved = true;
          }

          const walk = (x - startX) * 1.5;
          sliderContainer.scrollLeft = scrollLeft - walk;
          $('.collocation-modal').hide();
        });

        sliderContainer.addEventListener('touchend', () => {
          isDragging = false;
          $('.collocation-modal').hide();
        });
      }
        // ========== 滚动条滑块逻辑 ==========
        function updateScrollThumb() {
          if (!scrollContainer || !scrollThumb) return;

          const containerWidth = scrollContainer.scrollWidth - scrollContainer.clientWidth;
          const scrollPosition = scrollContainer.scrollLeft;

          if (containerWidth <= 0) {
            scrollThumb.style.width = '100%';
            scrollThumb.style.left = '0';
            return;
          }

          const thumbWidth = (scrollContainer.clientWidth / scrollContainer.scrollWidth) * 100;
          scrollThumb.style.width = thumbWidth + '%';

          let thumbPosition = (scrollPosition / containerWidth) * (100 - thumbWidth);
          thumbPosition = Math.max(0, Math.min(thumbPosition, 100 - thumbWidth));
          scrollThumb.style.left = thumbPosition + '%';
        }

        // 初始化滑块
        updateScrollThumb();

        // 监听滚动和窗口变化
        scrollContainer.addEventListener('scroll', updateScrollThumb);
        window.addEventListener('resize', updateScrollThumb);

        // 添加 CSS 样式确保触摸滚动平滑
        sliderContainer.style.cssText += `
          -webkit-overflow-scrolling: touch;
          overflow-scrolling: touch;
          scroll-behavior: smooth;
        `;
      }
    }

    function initLazyImages(container) {
      const imgs = container.querySelectorAll('.lazy-img');

      const io = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;

            const img = entry.target;
            const src = img.dataset.src;

            if (src) {
              img.src = src;
              img.removeAttribute('data-src');
            }

            observer.unobserve(img);
          });
        },
        {
          root: null,
          rootMargin: '200px', // 快滑到前 200px 就开始加载
          threshold: 0.01
        }
      );

      imgs.forEach(img => io.observe(img));
    }


    getSceneData();
    function getSceneData() { 
      let product_handle = '';
      if(window.location.pathname.indexOf('products') > -1){
        product_handle = window.location.pathname.split('/')[ window.location.pathname.split('/').length - 1 ];
      }
      fetchRequest(`${heychic_api}/web/active/outfit/list?product_handle=${product_handle}`, "GET")
      .then((res) => {
          if(res.code == 200){
            const sceneData = res.data;
            tag_list_get = sceneData.tag_list;//分类列表
            product_list_get = sceneData.data_list;
            
            if(window.location.pathname.indexOf('products') > -1){
              listProduct(product_list_get);
            }else{
              listProduct(tag_list_get);
            }

            // 筛选tag数据
            renderCategoryList(tag_list_get);
          }
      })
      .catch((error) => {
          console.error("GET Error:", error);
          $('.collocation-cont-right-all').removeClass('has-halo-block-loader');
      }); 
    }

    // 底部轮播
    function botImgSwiper() { 
      const sliderEl = document.querySelectorAll(".collocation-cont-right-item");

      sliderEl.forEach((sliderEl) => { 
        const sliderElTop = sliderEl.querySelector(".collocation-swiper-pic");
        const sliderElBot = sliderEl.querySelector(".collocation-swiper");

        const thumbsSwiperProduct = new Swiper(sliderElBot, {
          slidesPerView: 'auto',
          spaceBetween: 5,
          watchSlidesVisibility: true,
          centeredSlidesBounds: true,
        });

        const mySwiper = new Swiper(sliderElTop, {
            slidesPerView: 1,
            allowTouchMove: window.location.pathname.includes("/products") ? false : true,      // 关键：禁止触摸滑动
            thumbs: {
            swiper: thumbsSwiperProduct
          }
        })
      })
    }

    function listProduct(tag_list) { 
      let product_ids = [];// 产品ID列表

      if(window.location.pathname.includes('/products')){ 
        newRenderProductList = tag_list;
      }else{
        tag_list.forEach((r,t) => { 
          renderProductList.push(r.data_list);
        })
        newRenderProductList = [...new Map(renderProductList.flat().map(d => [d.id, d])).values()]; //去重(id)
      }

      newRenderProductList.forEach((item) => { 
        product_lists.push(item.material_config.product_data);
      })

      let product_lists_new = [...new Map(product_lists.flat().map(y => [y.product_number, y])).values()]; //去重(product_number) 

      product_lists_new.forEach((item) => {
        product_ids.push(`gid://shopify/Product/${item.product_number}`);
      })

      const query = `
        query getProducts(
          $ids: [ID!]!,
          $country: CountryCode
        ) @inContext(country: $country) {

          nodes(ids: $ids) {
            ... on Product {
              id
              title
              handle

              # ✅ 产品层价格（你要的）
              priceRange {
                minVariantPrice {
                  amount
                  currencyCode
                }
                maxVariantPrice {
                  amount
                  currencyCode
                }
              }

              featuredImage {
                url
              }

              variants(first: 100) {
                nodes {
                  id
                  title
                  availableForSale
                  quantityAvailable

                  # SKU 价格（可选，切变体时用）
                  price {
                    amount
                  }
                }
              }
            }
          }
        }
      `;



      fetch(`${graphql_api}/api/2024-01/graphql.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': graphql_token,
        },
        body: JSON.stringify({
          query,
          variables: {
            ids: product_ids,
            country: window.Shopify.country
          }
        })
      })
      .then(res => res.json())
      .then(res => {
        if(res.data){
          all_product_list = res.data.nodes;

          if(window.location.pathname.indexOf('products') > -1){
            if(product_list_get.length > 0){
              rightCategoryProduct(product_list_get);
              if(product_list_get.length <= 2){
                $('.product-collocation .scroll-bar').hide();
              }else{
                $('.product-collocation .scroll-bar').show();
              }
            }else{
              $('.product-collocation').hide();
              $('.product-upsell-box').show();
            }
            
          } else {
            // 产品数据(单独页面)
            rightCategoryProduct(tag_list_get);
          }
        }
      })
      .catch(error => console.error('Error:', error));
    }

    // 产品详情
    window.collocationDetail = function(id,j) {
      if (hasMoved) {
        hasMoved = false; // 重置
        return;
      }

      if(window.location.pathname.indexOf('products') > -1 && window.innerWidth < 768){
        // 场景搭配详情弹框显示,隐藏底部加购
        $('.productView-stickyCart').hide();
      }

      $('.collocation-modal').empty();

      // 筛选对应详情
      let filterProductObj;
      let productIdList; // 产品id列表
      filterProductObj = newRenderProductList.find(e => e.id == id);

      productIdList = filterProductObj.material_config.product_data.map((v,j) => {
        return `gid://shopify/Product/${v.product_number}`
      })

      $('.collocation-modal').show();

      const getProducts = all_product_list.filter(item =>
        productIdList.includes(item.id)
      );

        $('.collocation-modal').append(
      `
      <div class="collocation-modal-content">
        <div class="h5-close-all">
          <div class="title-name-pc">${filterProductObj.title}</div>
          <img src="https://cdn.heychic.net/material/review/close-b399a262fb4c044.png" class="collocation-modal-close-h5" onclick="closeModalProduct()" alt="close">
        </div>
        
        <div class="collocation-modal-img-thumbs">
          <div class="collocation-modal-content-left swiper">
            <div class="swiper-wrapper">
              ${
                filterProductObj?.material_config?.show_data.map((t,index) => {
                  if(filterProductObj.type == 1){
                    return `<img src="${t.url}" alt="" class="swiper-slide collocation-modal-content-left-img">`
                  }else{
                    return `<video class="detail-video" src="${t.url}" autoplay loop muted playsinline webkit-playsinline></video>`
                  }
                  
                }).join('')
              }
            </div>
          </div>
          <div class="swiper-thumbs-product-bot" style="${filterProductObj == 2 ? 'display:none;' : ''}">
            <div class="swiper-thumbs-product swiper">
              <div class="swiper-wrapper content-bot-bg">
                ${
                  filterProductObj?.material_config?.show_data.map((e,w) => {
                    return `<img src="${filterProductObj.type == 1 ? e.url : e.cover}" alt="" class="swiper-slide collocation-modal-content-bot-img">`
                  }).join('')
                }
              </div>
            </div>
          </div>
          
        </div>

        <div class="collocation-modal-content-right">
          <div class="modal-title ${window.innerWidth < 768 && !filterProductObj.content ? 'title-name-mobile' : ''}">
            <div class="title-name">${filterProductObj.title}  <img src="https://cdn.heychic.net/material/review/close-b399a262fb4c044.png" class="collocation-modal-close-pc" onclick="closeModalProduct()" alt="close"></div>
            <div class="title-desc">${filterProductObj.content}</div>
          </div>
          <div class="modal-product">
            ${
              getProducts.map((item,index) => {
                const variants = item?.variants?.nodes;
                if(variants?.length > 0){
                  const hideSize =
                    variants.length === 1 &&
                    variants[0].title === 'Default Title';

                    let firstTitleSelect = '';
                    let selectTitleList = item.variants.nodes.filter(e => e.availableForSale);
                    // 筛选第一个可用的size
                    if(selectTitleList.length > 0){ 
                      firstTitleSelect = selectTitleList[0].title;
                    }

                    return `
                      <div class="modal-product-item">
                        <a onclick="detailProduct('${item.handle}')">
                          <img src="${filterProductObj?.material_config?.product_data[index].product_image}" alt="modal-product-item-img" class="modal-product-item-img">
                          <div class="modal-product-item-name">${item.title}</div>
                          <div class="modal-product-item-price">
                          ${getCurrencySymbolAll(window.Shopify.currency.active)}${item.priceRange?.maxVariantPrice.amount} ${window.Shopify.currency.active}</div>
                        </a>
                        <div class="modal-product-size" style="display:${hideSize ? 'none' : 'flex'};">
                          ${
                            item.variants.nodes.map(e => {
                              return `<div data-availableForSale="${e.availableForSale}"  data-product-id="${item.id}" data-variant-id="${e.id}" class="size-item-scene size-item ${e.title == firstTitleSelect ? 'size-item-active' : ''} ${e.availableForSale ? '' : 'sold-out'}" onclick="selectSize(this)">${e.title}</div>`
                            }).join('')
                          }
                        </div>
                      </div>`
                }
              }).join('')  
            }
          </div>
          <div class="buy-button-all">
            <div class="buy-button" data-cart-sidebar onclick="goToCart()">ADD TO BAG</div>
          </div>
        </div>
      </div>
      `
    )
      const sizeItemsAll = document.querySelectorAll('.size-item-scene');
      // 检测所有变体是否都售罄
      const allSoldOut = [...sizeItemsAll].every(
        item => item.getAttribute('data-availableForSale') === 'false'
      );

      if(allSoldOut){
        $('.buy-button-all .buy-button').addClass('sold-out-btn');
      }else{
        $('.buy-button-all .buy-button').removeClass('sold-out-btn');
      }


      modalImgSwiper(j);
      autoSelectAvailableVariants();
    }

    function modalImgSwiper(j) { 
      const sliderEl = document.querySelectorAll(".collocation-modal-img-thumbs");
      sliderEl.forEach((sliderEl) => { 
        const sliderElTop = sliderEl.querySelector(".collocation-modal-content-left");
        const sliderElBot = sliderEl.querySelector(".swiper-thumbs-product");

        const thumbsSwiper = new Swiper(sliderElBot, {
          slidesPerView: 5,
          spaceBetween: 5,
          watchSlidesProgress: true,
          centeredSlidesBounds: true,
        });

        const mySwiper = new Swiper(sliderElTop, {
          slidesPerView: 1,
          initialSlide: j ? j : 0,
          thumbs: {
          swiper: thumbsSwiper
        }
        });
      })
    } 

    // 抽取变体逻辑
    function upsertVariant({ variantGid, productId,availableForSale }) {
      const variantId = variantGid.split('/').pop();

      const existingIndex = variant_id_list.findIndex(
        item => item.productIdentifier === productId
      );

      const data = {
        id: variantId,
        quantity: 1,
        productIdentifier: productId,
        availableForSale: availableForSale,
      };

      if (existingIndex > -1) {
        variant_id_list[existingIndex] = data;
      } else {
        variant_id_list.push(data);
      }
    }

    // 自动选择有库存的变体
    function autoSelectAvailableVariants() {
      variant_id_list = [];

      // 为每个产品项选择第一个有库存的变体
      $('.modal-product-item').each(function() {
        const productItem = $(this);
        const firstAvailableSize = productItem.find('.size-item[data-availableForSale="true"]').first();
        
        if (!firstAvailableSize.length) return;

        upsertVariant({
          variantGid: firstAvailableSize.attr('data-variant-id'),
          productId: firstAvailableSize.attr('data-product-id'),
          availableForSale: firstAvailableSize.attr('data-availableForSale')
        });
      });
    }

    window.detailProduct = function(handle) {
      closeModalProduct();
      window.location.href = `/products/${handle}`;
    }

    window.selectSize = function(e) {
      // 更新界面显示
      $(e).parents('.modal-product-size-select').find('.size-text').text($(e).text());
      
      upsertVariant({
        variantGid: $(e).attr('data-variant-id'),
        productId: $(e).attr('data-product-id'),
        availableForSale: $(e).attr('data-availableForSale')
      });

      // // 检查是否可售
      // const availableForSale = $(e).attr('data-availableForSale') === 'true';
      // if (!availableForSale) {
      //   $(e).parents('.modal-product-item').find('.soldOut-text').show();
      // } else {
      //   $(e).parents('.modal-product-item').find('.soldOut-text').hide();
      // }

      // const soldOutItems = document.querySelectorAll('.soldOut-text');

      // const allIsBlock = Array.from(soldOutItems).every(item => {
      //   return window.getComputedStyle(item).display === 'block';
      // });

      // // 检测所选变体是否都售罄
      // if(allIsBlock){
      //   $('.buy-button-all .buy-button').addClass('sold-out-btn');
      // }else{
      //   $('.buy-button-all .buy-button').removeClass('sold-out-btn');
      // }

      // 更改选中size样式
      $(e).addClass('size-item-active').siblings().removeClass('size-item-active');
      // $('.buy-button-all .buy-button').addClass('sold-in-btn');
    }

    window.showProductSize = function(e) {
      $(e).find('.size-list').toggle();
      $(e).find('.botTriModal').toggleClass('botTriModalActive');
    }

    window.closeModalProduct = function() {
      $('.collocation-modal').hide();
      if(window.location.pathname.indexOf('products') > -1 && window.innerWidth < 768){
        // 场景搭配详情弹框显示,隐藏底部加购
        $('.productView-stickyCart').show();
      }
    }

    window.goToCart = function() {
      closeModalProduct();
      // 筛选出可售的尺码
      const variantIdList =  variant_id_list.filter(item => item.availableForSale == 'true');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items:variantIdList
        })
      })
      .then(res => res.json())
      .then(data => {
        if(data.status === 422){
          showToastTips(data.message, 'error')
        }else{
          var cartNumberProduct = parseInt($('#cart-number-pc').text());
          $('#cart-number-pc').text(cartNumberProduct + variantIdList.length);

          var cartNumberH5 = parseInt($('#cart-number').text());
          $('#cart-number').text(cartNumberH5 + variantIdList.length);
        }
        
      });
    }
  })